import * as React from 'react';
import { Field } from 'redux-form';
import { jsx as _jsx } from "react/jsx-runtime";
const FormField = props => /*#__PURE__*/_jsx(Field, {
  id: props.id || props.name,
  ...props
});
export default FormField;